<template>
    <div class="wrapper tab-testimonial" :class="'is-' + variant">
        <figure class="testimonial-avatar">
            <img
                :src="person.avatar"
                :srcset="person.avatar + ' 1x, ' + person.avatar2x + ' 2x'"
                alt=""
            >
        </figure>

        <blockquote class="testimonial-quote">
            <span class="section-title testimonial-accent">Stimmen aus der Vitadio-Community</span>

            <p class="new-headline-lg"><span class="mark">“</span>{{ person.quote }}<span class="mark">”</span></p>

            <footer>
                <strong class="new-headline-md testimonial-accent">{{ person.name }}</strong>
                <span class="new-text-xl">{{ person.detail }}</span>
            </footer>

            <v-button label="Weiter" @onClick="$emit('answer')"></v-button>
        </blockquote>
    </div>
</template>

<script>
    const PEOPLE = {
        woman: {
            quote: 'Ich hätte nie gedacht, dass kleine Veränderungen so viel bewirken können. Heute habe ich mehr Energie, bessere Blutzuckerwerte und fühle mich wieder richtig wohl.',
            name: 'Anja',
            detail: '48 Jahre · Vitadio Teilnehmerin',
            avatar: 'imgs/web/img_testimonial_anja.png',
            avatar2x: 'imgs/web/img_testimonial_anja@2x.png'
        },
        men: {
            quote: 'Ich habe fast 10 kg verloren und komme heute sogar Treppen wieder leichter hoch. Das Programm hat mich jeden Tag motiviert dranzubleiben.',
            name: 'Jürgen',
            detail: '64 Jahre · Vitadio Teilnehmer',
            avatar: 'imgs/web/img_testimonial_juergen.png',
            avatar2x: 'imgs/web/img_testimonial_juergen@2x.png'
        }
    }

    export default {
        props: {
            variant: {
                type: String,
                required: false,
                default: 'woman'
            }
        },

        computed: {
            person() {
                return PEOPLE[this.variant] || PEOPLE.woman
            }
        }
    }
</script>
